import { text } from "../utils/i18n";
import { createTemporaryId, isCreated } from "../utils/model";
import { CallFilters, listCallFilterDescriptions } from "./CallFilters";
import { CallTag } from "./CallTag";
import OfferFilters, { listOfferFilterDescriptions } from "./OfferFilters";
import { OfferTemplate } from "./OfferTemplate";
import OrderFilters, { listOrderFilterDescriptions } from "./OrderFilters";
import OrderTag from "./OrderTag";
import { Products } from "./Products";
import { Users } from "./Users";

export enum LeadListFilterType {
  Calls = 'calls',
  Offers = 'offers',
  Orders = 'orders'
}

type FiltersDescriptionParams = {
  orderTags: ById<OrderTag>;
  callTags: ById<CallTag>;
  offerTemplates: OfferTemplate[];
  products: Products;
  users: Users;
};

export class LeadListFilter {
  readonly id: string = createTemporaryId();
  readonly type: LeadListFilterType = null;
  readonly filters: Partial<OrderFilters> | Partial<OfferFilters> | Partial<CallFilters> = {};
  readonly isAdded: boolean;

  constructor(deriveFrom?: Partial<LeadListFilter>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    this.isAdded = this.isAdded ?? isCreated(this.id);
  }

  getTitle(filtersArgs?: FiltersDescriptionParams): string {
    let title: string = '';

    if (this.type === LeadListFilterType.Orders) {
      title = text`Har order`;

    } else if (this.type === LeadListFilterType.Calls) {
      title = text`Har blivit uppringd`;

    } else if (this.type === LeadListFilterType.Offers) {
      title = text`[singular] Har avtal`;
    }

    if (!filtersArgs) {
      return title;
    }

    const description = this.getFiltersDescription(filtersArgs);

    if (description) {
      return `${title} (${description})`;
    }

    return title;
  }

  getFiltersDescription(args: FiltersDescriptionParams): string {
    if (this.type === LeadListFilterType.Orders) {
      return listOrderFilterDescriptions(
        this.filters as Partial<OrderFilters>,
        args.orderTags,
        args.products
      ).join(', ');

    } else if (this.type === LeadListFilterType.Calls) {
      return listCallFilterDescriptions(
        this.filters as Partial<CallFilters>,
        args
      ).join(', ');

    } else if (this.type === LeadListFilterType.Offers) {
      return listOfferFilterDescriptions(
        this.filters as Partial<OfferFilters>,
        args.offerTemplates
      ).join(', ');
    }

    return '';
  }
}

export class LeadListFilterConfig {

  readonly filters: LeadListFilter[] = [];

  /**
   * Whether the conditions must be AND, otherwise OR.
   */
  readonly and: boolean = true;

  constructor(deriveFrom?: Partial<LeadListFilterConfig>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    this.filters = this.filters.map(condition =>
      new LeadListFilter(condition));
  }
}